import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-shell__view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppLayout = _resolveComponent("AppLayout")!
  const _component_AppDialogHost = _resolveComponent("AppDialogHost")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.rootClasses)
  }, [
    (_ctx.useAuthenticatedShell)
      ? (_openBlock(), _createBlock(_component_AppLayout, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_router_view)
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
    _createVNode(_component_AppDialogHost)
  ], 2))
}